<template>
  <article class="post post--card post--event">
    <div v-html="event.images"></div>
    <a :href="event.url">
      <div class="post__details">
        <h2 class="post__title">{{event.title}}</h2>
        <div v-html="event.date"></div>
        <p class="post__summary" v-html="event.precis"></p>
        <p class="post__location">
          <span v-html="event.location"></span>
        </p>
      </div>
    </a>
  </article>
</template>
<script>
    export default {
    props: {
      event: Object
    }
  }
</script>
